// utils/UserUtils.js

const USER_KEY = "memberUser";

export const loginUser = (user) => {
  if (!user) return;
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getCurrentUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

// LOGOUT
export const logoutUser = () => {
  localStorage.removeItem(USER_KEY);

  // Backend clears HttpOnly cookie
  window.location.href = "/login";
};

// AUTH CHECK (COOKIE-BASED)
export const isLoggedIn = () => {
  return !!getCurrentUser();
};

// UPDATE USER
export const updateUser = (updatedUser) => {
  if (!updatedUser) return;

  const existing = getCurrentUser() || {};

  const merged = {
    ...updatedUser,
    token: existing.token,
  };

  localStorage.setItem(USER_KEY, JSON.stringify(merged));
};
